import SockJS from 'sockjs-client'
import myServer from '@/myServer'
import Stomp from 'stompjs'
/**
 * 设置新websocket
 * @param Authorization token
 * @param url 路径
 * @param destination
 */
export const setWsSocket = ({ Authorization, url }) => {
  return new Promise((resolve) => {
    let socket = new SockJS(url + '?access_token=' + Authorization)
    // eslint-disable-next-line no-undef
    resolve(Stomp.over(socket))
  })
}

/**
 * 设置连接 返回数据
 * @param stompClient
 * @param destination
 */
export const wsRtnConnect = (stompClient, destination) => {
  // connect to the server
  return new Promise((resolve) => {
    stompClient.connect({}, function () {
      // upon connection, subscribe to the destination
      const sub = stompClient.subscribe(destination, function (res) {
        let params = {
          sub,
          data: res.body
        }
        myServer.$emit(destination, params)
        resolve(params)
      })
    })
  })
}

/**
 * 取消endpoint
 * @param sub
 */
export const wsSubCancel = (sub) => {
  //... unsubscribe from the destination
  sub.unsubscribe()
}

/**
 * 取消连接
 * @param stompClient
 */
export const wsSocketCancel = (stompClient) => {
  stompClient.disconnect()
}
